import { NgModule } from '@angular/core';
import { MtxPhotoviewer } from './photoviewer';

@NgModule({
  imports: [],
  exports: [MtxPhotoviewer],
  declarations: [MtxPhotoviewer],
})
export class MtxPhotoviewerModule {}
